var _circle, _circle2, _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _line2, _rect17, _rect18, _rect19, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 280,
    viewBox: "0 0 295 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 140,
    fill: "#F3F3F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3443_182431",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 280,
    height: 280
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 140,
    fill: "#DEDEE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3443_182431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7911 63.2679C47.6529 52.4296 38.1255 44.293 26.6799 44.293C17.5926 44.293 9.70021 49.4451 5.76973 56.9848C-3.69487 57.9901 -11.0527 66.0011 -11.0527 75.7085C-11.0527 86.107 -2.59434 94.5578 7.81358 94.5578H48.6906C57.3691 94.5578 64.4125 87.5207 64.4125 78.85C64.4125 70.5563 57.9665 63.8334 49.7911 63.2679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.219 32.6825C106.227 27.7231 101.808 24 96.5 24C92.2854 24 88.625 26.3575 86.8021 29.8075C82.4125 30.2675 79 33.9331 79 38.375C79 43.1331 82.9229 47 87.75 47H106.708C110.733 47 114 43.78 114 39.8125C114 36.0175 111.01 32.9412 107.219 32.6825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.621 86.0062C235.759 75.1679 245.287 67.0312 256.732 67.0312C265.819 67.0312 273.712 72.1834 277.642 79.7231C287.107 80.7284 294.465 88.7394 294.465 98.4468C294.465 108.845 286.006 117.296 275.599 117.296H234.722C226.043 117.296 219 110.259 219 101.588C219 93.2946 225.446 86.5717 233.621 86.0062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3 47.7025C189.66 41.0181 195.72 36 203 36C208.78 36 213.8 39.1775 216.3 43.8275C222.32 44.4475 227 49.3881 227 55.375C227 61.7881 221.62 67 215 67H189C183.48 67 179 62.66 179 57.3125C179 52.1975 183.1 48.0512 188.3 47.7025Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.665 86.8868L144.727 49.0043C143.645 47.3873 141.823 46.5789 140.001 46.5789C138.179 46.5789 136.357 47.3873 135.275 49.062L110.336 86.8868H83.0629C79.9313 86.8868 77.3691 89.4855 77.3691 92.6616C77.3691 93.1813 77.4261 93.701 77.5969 94.2208L92.0591 147.753C93.3687 152.604 97.7529 156.184 102.991 156.184H177.01C182.249 156.184 186.633 152.604 187.999 147.753L202.461 94.2208L202.632 92.6616C202.632 89.4855 200.07 86.8868 196.939 86.8868H169.665ZM122.919 86.8868L140.001 61.4778L157.082 86.8868H122.919ZM140.001 133.085C133.738 133.085 128.613 127.888 128.613 121.535C128.613 115.183 133.738 109.986 140.001 109.986C146.264 109.986 151.388 115.183 151.388 121.535C151.388 127.888 146.264 133.085 140.001 133.085Z",
    fill: "white",
    stroke: "#A6A8BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 226.836,
    width: 238.249,
    height: 38.4273,
    rx: 4,
    fill: "#A6A8BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02854,
    y: 222.642,
    width: 245.1,
    height: 37.5929,
    rx: 3.58279,
    fill: "#F3F3F7",
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9824,
    y: 237.596,
    width: 7.68546,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8906,
    y: 237.596,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2266,
    y: 237.596,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 147.561,
    y: 237.596,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.357,
    y: 237.596,
    width: 34.5846,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 223.296,
    y1: 222.225,
    x2: 223.296,
    y2: 260.652,
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 223.646,
    y: 233.753,
    width: 26.1306,
    height: 15.3709,
    fill: "#F3F3F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 232.869,
    y: 237.596,
    width: 7.68546,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.2695,
    y: 172.243,
    width: 238.249,
    height: 38.4273,
    rx: 4,
    fill: "#A6A8BB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2981,
    y: 168.049,
    width: 245.1,
    height: 37.5929,
    rx: 3.58279,
    fill: "#F3F3F7",
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64.252,
    y: 183.002,
    width: 7.68546,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1602,
    y: 183.002,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 136.496,
    y: 183.002,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 191.83,
    y: 183.002,
    width: 46.1128,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 245.629,
    y: 183.002,
    width: 34.5846,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 267.566,
    y1: 167.632,
    x2: 267.566,
    y2: 206.059,
    stroke: "#A6A8BB",
    strokeWidth: 0.834422
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 267.918,
    y: 179.16,
    width: 26.1306,
    height: 15.3709,
    fill: "#F3F3F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 277.141,
    y: 183.002,
    width: 7.68546,
    height: 7.68546,
    rx: 3.84273,
    fill: "#A6A8BB"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 169.697,
    y: 40.1316,
    width: 41,
    height: 30,
    rx: 4,
    fill: "#A6A8BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.2 60.2576C189.08 60.2576 188.221 59.8236 187.624 58.9556C187.027 58.0876 186.728 56.8323 186.728 55.1896C186.728 53.5376 187.027 52.2823 187.624 51.4236C188.221 50.5649 189.08 50.1356 190.2 50.1356C191.329 50.1356 192.188 50.5649 192.776 51.4236C193.373 52.2823 193.672 53.5329 193.672 55.1756C193.672 56.8276 193.373 58.0876 192.776 58.9556C192.179 59.8236 191.32 60.2576 190.2 60.2576ZM190.2 59.2496C190.984 59.2496 191.567 58.9183 191.95 58.2556C192.333 57.5929 192.524 56.5663 192.524 55.1756C192.524 53.7756 192.333 52.7536 191.95 52.1096C191.567 51.4563 190.984 51.1296 190.2 51.1296C189.425 51.1296 188.842 51.4563 188.45 52.1096C188.067 52.7629 187.876 53.7849 187.876 55.1756C187.876 56.5663 188.067 57.5929 188.45 58.2556C188.842 58.9183 189.425 59.2496 190.2 59.2496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.783 76.7174L183.369 71.3032C182.619 70.553 181.601 70.1316 180.54 70.1316H199.854C198.793 70.1316 197.776 70.553 197.026 71.3032L191.611 76.7174C190.83 77.4984 189.564 77.4984 188.783 76.7174Z",
    fill: "#A6A8BB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransactions);
export default __webpack_public_path__ + "static/media/empty_transactions.1059ce3fd165d53856599168008f63de.svg";
export { ForwardRef as ReactComponent };